export const environment = {
  production: false,
  environmentName: 'dev',
  apiUrl: 'https://dev-api-sports.vkomaktechnologies.com/api',
  razorpayKey: 'rzp_test_Si0s9UuWIczRvP'
};
